import {
  CircularProgress,
  FormControl,
  type FormControlProps,
  FormErrorMessage,
  FormLabel,
  type FormLabelProps,
  Input,
  InputGroup,
  type InputProps,
  InputRightElement
} from '@chakra-ui/react'
import { Controller, type ControllerProps } from 'react-hook-form'
import { type PostNordCheckoutFormValues } from './types'

export const PostNordFormFieldLabel = (props: FormLabelProps) => {
  return <FormLabel fontSize="sm" color="text.mild" {...props} />
}

interface PostNordFormFieldProps {
  name: keyof PostNordCheckoutFormValues
  label: string
  isLoading?: boolean
  formControlProps?: FormControlProps
  inputProps?: InputProps
  controllerProps?: Partial<ControllerProps>
}

export const PostNordFormField = ({
  name,
  label,
  isLoading,
  formControlProps,
  inputProps,
  controllerProps
}: PostNordFormFieldProps) => {
  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => (
        <FormControl {...formControlProps} isInvalid={fieldState.invalid}>
          <PostNordFormFieldLabel>{label}</PostNordFormFieldLabel>

          <InputGroup>
            <Input {...inputProps} {...field} placeholder={label} />
            {isLoading && (
              <InputRightElement>
                <CircularProgress isIndeterminate size="var(--input-font-size)" />
              </InputRightElement>
            )}
          </InputGroup>

          <FormErrorMessage>{fieldState.error?.message}</FormErrorMessage>
        </FormControl>
      )}
      {...controllerProps}
    />
  )
}
